function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Cleave from 'cleave.js/react';
import { Icon } from '../Icon';
var Field = React.forwardRef(function (props, ref) {
  var dateField = props.dateField,
      className = props.className,
      wrapperClassName = props.wrapperClassName,
      iconleft = props.iconleft,
      iconright = props.iconright,
      hasError = props.hasError,
      size = props.size,
      formattingOptions = props.formattingOptions,
      otherProps = _objectWithoutProperties(props, ["dateField", "className", "wrapperClassName", "iconleft", "iconright", "hasError", "size", "formattingOptions"]);

  var fieldClass = classNames('field', 'bw-1', 'bs-solid', 'w-100p', 'p-2', 'box-border', 'br-4', 'fs-2', 'c-neutral-900', {
    'h-8': size === 'sm',
    'h-9 fs-3': size === 'md',
    'fs-3 h-10': size === 'lg',
    'bc-neutral-100 c-neutral-900': !hasError,
    'bc-error-500': hasError,
    'focus:bc-secondary-500': !hasError,
    'pl-7': iconleft
  }, className);
  var iconLeftClassName = classNames('field__icon', {
    'field__icon-left--sm': size === 'sm',
    'field__icon-left': size === 'md',
    'field__icon-left--lg': size === 'lg'
  });
  var iconRightClassName = classNames('field__icon', {
    'field__icon-right--sm': size === 'sm',
    'field__icon-right': size === 'md',
    'field__icon-right--lg': size === 'lg'
  });
  var wrapperClass = classNames(wrapperClassName, 'p-relative');
  var defaultOptions = {
    date: true,
    datePattern: ['d', 'm', 'Y'],
    delimiter: ' / '
  };
  return React.createElement("div", {
    className: wrapperClass
  }, dateField || formattingOptions ? React.createElement(Cleave, _extends({
    ref: ref,
    options: formattingOptions ? formattingOptions : defaultOptions,
    className: fieldClass
  }, otherProps)) : React.createElement("input", _extends({
    ref: ref,
    className: fieldClass
  }, otherProps)), iconleft && React.createElement(Icon, {
    icon: iconleft,
    className: iconLeftClassName
  }), iconright && React.createElement(Icon, {
    icon: iconright,
    className: iconRightClassName
  }));
});
Field.propTypes = {
  /**
   * Class to be appended to the wrapping element
   */
  className: PropTypes.string,

  /**
   * Html type of the input text/number/email etc.
   */
  type: PropTypes.string,

  /**
   * Boolean to indicate an error state
   */
  hasError: PropTypes.bool,

  /**
   * Icon string to append to the right of the field
   */
  iconleft: PropTypes.string,

  /**
   * Icon string to append to the left of the field
   */
  iconright: PropTypes.string,

  /**
   * Classes for internal wrapper
   */
  wrapperClassName: PropTypes.string,

  /**
   * Size of the input filed
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),

  /**
   * Date input field variant
   */
  dateField: PropTypes.bool,

  /**
   * Card input field variant
   */
  formattingOptions: PropTypes.object
};
Field.defaultProps = {
  className: '',
  type: 'text',
  iconleft: null,
  iconright: null,
  wrapperClassName: '',
  hasError: false,
  size: 'md',
  dateField: false,
  formattingOptions: null
};
Field.displayName = 'Field';
export default Field;